module.exports = __webpack_public_path__ + "img/21.1c6cdd58.png";